import { ContractDurationType, type ContractDurationDto, type EventOptionsDto, type FrameworkAgreementType } from "../../../../../autogen/bff-api";
import { displayDate } from "../../../../../common/formatting/displayDate";
import { isFrameworkEnabled } from "./publicProcurementOptions";

export const formatContractDuration = (
  duration: ContractDurationDto | undefined,
  t: (key: string) => string
): string => {
  if (!duration) return "-";
  if (duration.type === ContractDurationType.OpenEnded) return t("Running agreement");
  if (duration.type === ContractDurationType.FixedDates && duration.startDate && duration.endDate) {
    return `${displayDate(duration.startDate)} - ${displayDate(duration.endDate)}`;
  }
  if (duration.type === ContractDurationType.PeriodBased) {
    return duration.startDate ? displayDate(duration.startDate) : "-";
  }
  return "-";
};

export const formatContractOptions = (
  options: EventOptionsDto | undefined,
  t: (key: string) => string
): string => {
  if (!options || !options.hasOptions) return t("No");
  const count = options.descriptions.filter((d) => d.trim() !== "").length;
  if (count === 0) return t("Yes");
  return `${t("Yes")} (${count})`;
};

export const formatFrameworkAgreement = (
  agreement: FrameworkAgreementType | null | undefined,
  labels: Record<string, string>,
  t: (key: string) => string
): string => {
  if (!isFrameworkEnabled(agreement)) return t("No");
  return labels[agreement ?? ""] ?? agreement ?? "-";
};
